module.exports = __webpack_public_path__ + "static/img/index-carousel-04-01.6e1136e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-carousel-04-01.png
// module id = Ki+G
// module chunks = 0